import { render } from "./subTopicRelease.vue?vue&type=template&id=4f0966bf&scoped=true"
import script from "./subTopicRelease.vue?vue&type=script&lang=js"
export * from "./subTopicRelease.vue?vue&type=script&lang=js"

import "./subTopicRelease.vue?vue&type=style&index=0&id=4f0966bf&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0966bf"]])

export default __exports__